import { mapState } from "vuex";

export default {
    methods: {
        displayDinamicSwal(code, swalParams = {}) {
            return new Promise((resolve, reject) => {
                this.$swal.fire({
                    title: this.getPopUpTitle(code),
                    icon: swalParams.icon || 'info',
                    html: this.getPopUpBody(code),
                    showCancelButton: Boolean(swalParams.cancelButtonText),
                    cancelButtonColor: '#d33',
                    confirmButtonText: swalParams.confirmButtonText || 'Ok',
                    cancelButtonText: swalParams.cancelButtonText || ''
                }).then((result) => {
                    if (result.isConfirmed) {
                        resolve()
                    } else {
                        reject()
                    }
                })
            });

        },
        getPopUpBody(code) {
            return this.popUps.data && this.popUps.data.length > 0 ? this.popUps.data.find(p => p.code == code)['body'] : '';
        },
        getPopUpTitle(code) {
            return this.popUps.data && this.popUps.data.length > 0 ? this.popUps.data.find(p => p.code == code)['title'] : '';
        }
    },
    computed: {
        ...mapState('popUpsHtml', {
            popUps: state => state.popUps
        })
    }
}